import { isConnectedWeb } from '@grandstand-web/bally-web-shared/src/utils/appUtils'
import { TPlatform } from '../types'
import { isComcast } from './isComcast'
import { isTizen } from './isTizen'
import { isXbox } from './isXbox'

export const getPlatform = (): TPlatform => {
  if (isConnectedWeb()) {
    // These tests could possibly have false positives, so we want to ensure they never run on web
    if (isTizen()) {
      return 'tv_samsung'
    }
    if (isXbox()) {
      return 'tv_xboxone'
    }
    if (isComcast()) {
      return 'hbbtv'
    }
  }
  return 'web_browser'
}
